import React, { useRef, useState, useEffect, useCallback, useMemo } from "react";
import FormCreator from "../../components/forms/FormCreator";
import { CreateHonoraryMemberData } from "./data/CreateHonoraryMember.Data";
import { useLazyGetAllDropDownsForMemberQuery, useLazyGetPDFQuery, useStoreBase64ImageMutation, useUploadPDFMutation } from "../../app/services/common/commonServiceApi";
import { createHonoraryMemberFormDropdownConfigs } from "./utils/setDropdownFields";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { useNavigate } from "react-router-dom";
import { handleFieldChange, } from "./utils/handleFieldChange";
import Buttons from "../../components/ui/button/Buttons";
import SwalAlert from "../../services/swalService/SwalService";
import { saveAs } from 'file-saver'
import ToastService from "../../services/toastService/ToastService";
import { useCreateHonoraryMemberDetailsMutation } from "../../app/services/HonoraryMembers/HonoraryMembershipServiceApi";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import { onResetForm } from "../../utils/FormFields/ResetForm/handleResetForm";
import { getAuditContext } from "../../lib/authenticationLibrary";

const CreateHonoraryMemberForm = () => {
  const createHonoraryMemberFormRef = useRef();
  const [createHonoraryMemberForm, setEditViewIndividualMemberForm] = useState(CreateHonoraryMemberData);
  const navigate = useNavigate();
  const { error, success } = SwalAlert();
  const audit = getAuditContext();
  const [uploadedFileName, setUploadedFileName] = useState({
    displayPhotoUploadedName: "",
    displayPhotoEncryptedName: "",
    resumeWorkExpFile: "",
    resumeWorkExpEncFileName: "",
    relevantDiplomasCertificatesFile: "",
    relevantDiplomasCertificatesEncFileName: "",
    detailedListAppRoleRespoFile: "",
    detailedListAppRoleRespoFileEncFileName: "",
    firstCharacterRefFile: "",
    firstCharacterReffileEncFileName: "",
    secondCharacterRefFile: "",
    secondCharacterRefFileEncFileName: "",
    charaterRoleFile: "",
    charaterRoleFileEncFileName: "",
  });

  const [uploadFile, { isSuccess: isFileSuccess, isLoading: isFileLoading, data: uploadFileResponse }] = useUploadPDFMutation();
  const [imageUpload, { isSuccess: isImageSuccess, isLoading: isImageLoading, data: uploadImgResponse }] = useStoreBase64ImageMutation();
  const [getAllDropDowns, { isLoading: dropdownIsLoading, isSuccess: isSuccess, data: allDropDownResponse }] = useLazyGetAllDropDownsForMemberQuery();
  const [getPDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF, data: getPDFData }] = useLazyGetPDFQuery();
  const [saveMemberDetails, { isSuccess: saveMemberDetailsIsSuccess, isLoading: saveMemberDetailsIsLoading, data: saveMemberDetailsResponse }] = useCreateHonoraryMemberDetailsMutation();
  const createHonoraryFormInitState = {
    salutationId: "",
    firstName: "",
    lastName: "",
    displayName: "",
    DisplayPhoto: null,
    gender: "Male",
    dateofBirth: null,
    placeofBirth: "",
    nationalityId: null,
    last4DigitsofNRIC: "",
    workpass: "",
    mailingAddressLine1: "",
    mailingAddressLine2: "",
    mailingAddressLine3: "",
    countryId: null,
    postalCode: "",
    emailAddress: "",
    mobile: "",
    highestQualificationId: null,
    highestQualificationOthers: "",
    academicDegree: "",
    awardingBody: "",
    otherQualifications: "",
    currentlyEmployed: null,
    organisationCompany: "",
    jobTitle: "",
    jobRoleId: null,
    bio: "",
    organisationAddressLine1: "",
    organisationAddressLine2: "",
    organisationAddressLine3: "",
    empCountryId: null,
    empPostalCode: "",
    empEmailAddress: "",
    empMobile: "",
    linkdein: "",
    isPublicAccountantRegACRA: false,
    isCharteredAccountant: false,
    isAdvocateAndSolicater: false,
    isOtherProfessional: false,
    professionalInformationOther: "",
    iscriminaloffence: 'no',
    criminaloffenceMoreDetails: "",
    isBenifitsOfYourCreditors: 'no',
    benifitsOfYourCreditorsMoreDetails: "",
    resumeWorkExpFile: null,
    relevantDiplomasCertificatesFile: null,
    detailedListAppRoleRespoFile: null,
    yearsOfRIExp: "",
    firstCharacterRefFile: null,
    secondCharacterRefFile: null,
    isSubscribeToMailList: false,
  };
  useEffect(() => {
    getAllDropDowns();
  }, []);

  useEffect(() => {
    if (!isLoadingGetPDF && isSuccessGetPDF && getPDFData) {
      saveAs(getPDFData.fileData, getPDFData.fileName);
    }
  }, [isLoadingGetPDF, isSuccessGetPDF, getPDFData]);

  useEffect(() => {
    if (!dropdownIsLoading && isSuccess && allDropDownResponse) {
      if (allDropDownResponse) {
        // Updates dropdown fields in the form based on the fetched data
        setAllDropDownFieldsBatch(CreateHonoraryMemberData, createHonoraryMemberFormDropdownConfigs, allDropDownResponse);
      }
    }
  }, [dropdownIsLoading, isSuccess, allDropDownResponse]);

  useEffect(() => {
    if (!saveMemberDetailsIsLoading && saveMemberDetailsIsSuccess && saveMemberDetailsResponse) {

      if (saveMemberDetailsResponse?.errorMessage === 'Email Already exist') {
        error("Email already exists", "oops!");
      }
      else if (saveMemberDetailsResponse.keyId > 0) {
        success("New Honorary Member created successfully", "Success");
        onResetForm(createHonoraryMemberForm, setEditViewIndividualMemberForm, createHonoraryFormInitState);
      }
    }
  }, [saveMemberDetailsIsLoading, saveMemberDetailsIsSuccess, saveMemberDetailsResponse]);

  useEffect(() => {
    if (!isFileLoading && isFileSuccess && uploadFileResponse) {
      const storagePath = uploadFileResponse?.fileName?.split("\\")[1];
      setUploadResponseFileName(storagePath, uploadFileResponse?.uploadedFileName, uploadFileResponse?.fileName);
    }
  }, [isFileLoading, isFileSuccess, uploadFileResponse]);

  useEffect(() => {
    if (!isImageLoading && isImageSuccess && uploadImgResponse) {
      let storagePath = uploadImgResponse?.fileName?.split("\\")[1];
      if (storagePath === "PaymentProof") {
        storagePath = "profOfPaymentFile";
      }
      if (storagePath === "DisplayPhoto") {
        storagePath = "DisplayPhoto";
      }

      setUploadResponseFileName(storagePath, uploadImgResponse?.uploadedFileName, uploadImgResponse?.fileName);
      ToastService.success("Image has been uploaded successfully !");
    }
  }, [isImageLoading, isImageSuccess, uploadImgResponse]);

  // Handle file uploads
  const handleFileUpload = (fieldName, fileInfo) => {
    const formData = new FormData();
    formData?.append("file", fileInfo?.file);
    formData?.append("storagePath", fieldName);
    uploadFile(formData);
  };

  // Update state with uploaded file response
  const setUploadResponseFileName = (fieldName, fileName, encFileName) => {
    const validFields = {
      resumeWorkExpFile: "resumeWorkExpEncFileName",
      relevantDiplomasCertificatesFile: "relevantDiplomasCertificatesEncFileName",
      detailedListAppRoleRespoFile: "detailedListAppRoleRespoFileEncFileName",
      firstCharacterRefFile: "firstCharacterReffileEncFileName",
      secondCharacterRefFile: "secondCharacterRefFileEncFileName",
      charaterRoleFile: "charaterRoleFileEncFileName",
    };

    if (validFields[fieldName]) {
      setUploadedFileName((prevState) => ({
        ...prevState,
        [fieldName]: fileName,
        [validFields[fieldName]]: encFileName,
      }));
    }
  };

  const handleImageUpload = useCallback((fileDetails) => {
    const request = {
      fileName: fileDetails?.fileName,
      fileStr: fileDetails?.base64Data,
      storagePath: "DisplayPhoto",
    };
    imageUpload(request);
  }, [imageUpload]);

  const memoizedHandleFieldChange = (dataFieldName, updateFormData) => {
    if (dataFieldName === "DisplayPhoto")
      handleImageUpload(updateFormData?.DisplayPhoto)
    else if (["resumeWorkExpFile", "relevantDiplomasCertificatesFile", "detailedListAppRoleRespoFile", "firstCharacterRefFile", "secondCharacterRefFile"].includes(dataFieldName))
      handleFileUpload(dataFieldName, updateFormData[dataFieldName]);
    else {
      handleFieldChange(
        dataFieldName,
        updateFormData,
        CreateHonoraryMemberData
      )
    }
  }

  const handleSave = () => {
    const formData = createHonoraryMemberFormRef?.current?.getFormData();
    if (!formData || Object.keys(formData).length === 0) {
      error("Please fill all mandatory fields", "Error")
      return;
    }
    const request = {
      IPASMemberId: null,
      // AccountStatus: formData?.accountStatusId?.value || formData?.accountStatusId || null,
      // ReasonForLeaving: formData?.reasonforLeavingId || null,
      // JoiningDate: formData?.joiningDate || null,
      // AccountInformationUpdatedDate: formData?.accountInformationUpdatedDate || null,
      StatusId: 1,
      MembershipType: 7,
      // MemberShipTenur: formData?.membershipTensureId?.value || null,
      // PreferredStartDate: formData?.startDate || null,
      // SubscriptionUpdatedDate: formData?.startDate || null,
      // IsINSOLMembership: formData?.isINSOLMembership === "no" ? false : true || null,
      // INSOLMembershipReasonId: formData?.reasonId?.value || formData?.reasonId || null,
      FirstName: formData?.firstName || null,
      LastName: formData?.lastName || null,
      SalutationId: formData?.salutationId?.value || null,

      DisplayName: formData?.displayName || null,
      DisplayPhotoUploadedName: uploadImgResponse?.uploadedFileName || null,
      DisplayPhotoEncryptedName: uploadImgResponse?.fileName || uploadedFileName?.displayPhotoEncryptedName || null,
      IsGenderMale: formData?.gender === "male" ? true : false || null,
      DateOfBirth: formData?.dateofBirth || null,
      PlaceOfBirthId: formData?.placeofBirth?.value || formData?.placeofBirth || null,
      NationalityId: formData?.nationalityId?.value || formData?.nationalityId || null,
      NRIC: formData?.last4DigitsofNRIC || null,
      Workpass: formData?.workpass || null,
      AddressLine1: formData?.mailingAddressLine1 || null,
      AddressLine2: formData?.mailingAddressLine2 || null,
      AddressLine3: formData?.mailingAddressLine3 || null,
      CountryId: formData?.countryId?.value || null,
      PostalCode: formData?.postalCode || null,
      EmailAddress: formData?.emailAddress || null,
      Mobile: formData?.mobile || null,
      HighestQualificationAttained: formData?.highestQualificationId?.value || formData?.highestQualificationId,
      OtherEducationInformation: formData?.highestQualificationOthers || null,
      DegreeExaminationOrEquivalent: formData?.academicDegree || null,
      AwardingBody: formData?.awardingBody || null,
      OtherQualification: formData?.otherQualifications || null,
      IsCurrentlyEmployed: formData?.currentlyEmployed === "yes" ? true : false || null,
      OrganisationOrCompany: formData?.currentlyEmployed === "yes" ? formData?.organisationCompany : null,
      JobTitle: formData?.currentlyEmployed === "yes" ? formData?.jobTitle : null,
      JobRoleId: formData?.currentlyEmployed === "yes" ? formData?.jobRoleId?.value || formData?.jobRoleId : null,
      OrganisationAddressLine1: formData?.currentlyEmployed === "yes" ? formData?.organisationAddressLine1 : null,
      OrganisationAddressLine2: formData?.currentlyEmployed === "yes" ? formData?.organisationAddressLine2 : null,
      OrganisationAddressLine3: formData?.currentlyEmployed === "yes" ? formData?.organisationAddressLine3 : null,
      EmploymentCountryId: formData?.currentlyEmployed === "yes" ? formData?.empCountryId?.value : null,
      EmploymentPostalCode: formData?.currentlyEmployed === "yes" ? formData?.empPostalCode : null,
      EmploymentEmailAddress: formData?.currentlyEmployed === "yes" ? formData?.empEmailAddress : null,
      EmploymentMobile: formData?.currentlyEmployed === "yes" ? formData?.empMobile : null,
      Bio: formData?.bio || null,
      LinkedIn: formData?.linkdein || null,
      AccountantRegisteredWithACRA: formData?.isPublicAccountantRegACRA || null,
      CharteredAccountant: formData?.isCharteredAccountant || null,
      AdvocateAndSolicitor: formData?.isAdvocateAndSolicater || null,
      IsOtherProfessionalInformation: formData?.isOtherProfessional || null,
      OtherProfessionalInformation: formData?.isOtherProfessional === "yes" ? formData?.isOtherProfessionalReason : null,
      IsCriminalOffence: formData?.iscriminaloffence === "yes" || false || null,
      CriminalOffenceDetails: formData?.criminaloffenceMoreDetails || null,
      IsAdjudgedBankrupt: formData?.isBenifitsOfYourCreditors === "yes" || false,
      AdjudgedBankruptDetails: formData?.benifitsOfYourCreditorsMoreDetails || null,
      ResumeUploadedName: uploadedFileName?.resumeWorkExpFile || null,
      ResumeEncryptedName: uploadedFileName?.resumeWorkExpEncFileName || null,
      DiplomasCertificatesUploadedName: uploadedFileName?.relevantDiplomasCertificatesFile || null,
      DiplomasCertificatesEncryptedName: uploadedFileName?.relevantDiplomasCertificatesEncFileName || null,
      RoleResponsibilitiesFileUploadedName: uploadedFileName?.detailedListAppRoleRespoFile || null,
      RoleResponsibilitiesFileEncryptedName: uploadedFileName?.detailedListAppRoleRespoFileEncFileName || null,
      YearsOfRIExperience: formData?.yearsOfRIExp || null,
      FirstCharacterReferenceFileUploadedName: uploadedFileName?.firstCharacterRefFile || null,
      FirstCharacterReferenceFileEncryptedName: uploadedFileName?.firstCharacterReffileEncFileName || null,
      SecondCharacterReferenceFileUploadedName: uploadedFileName?.secondCharacterRefFile || null,
      SecondCharacterReferenceFileEncryptedName: uploadedFileName?.secondCharacterRefFileEncFileName || null,
      SubscribeToMailingList: formData?.isSubscribeToMailList || null,
      CreatedBy: audit.adminUserId,
      CreatedAppId: audit.appId,
    }
    console.log(request)
    saveMemberDetails(request);
  }
  const handleActionChange = (action, dataField) => {
    if (action === "DOWNLOAD") {
      handleDownload(dataField)
    }
  }
  const handleDownload = (dataField) => {
    const fetchEncFileName = {
      resumeWorkExpFile: "resumeWorkExpEncFileName",
      relevantDiplomasCertificatesFile: "relevantDiplomasCertificatesEncFileName",
      detailedListAppRoleRespoFile: "detailedListAppRoleRespoFileEncFileName",
      firstCharacterRefFile: "firstCharacterReffileEncFileName",
      secondCharacterRefFile: "secondCharacterRefFileEncFileName",
      DisplayPhoto: "displayPhotoEncFileName",
    };
    let fileName = fetchEncFileName[dataField];

    if (uploadImgResponse?.[fileName]?.includes('.png') || uploadImgResponse?.[fileName]?.includes('Images\\')) {

      let request = {
        type: dataField,
        fileName: uploadImgResponse?.fileName
      }

      getPDF(request)
    }
    else {
      let request = {
        type: dataField,
        fileName: uploadedFileName?.[fileName] || uploadImgResponse?.fileName,
      }
      getPDF(request)
    }
  }
  const handleBack = () => { navigate(-1); }
  const memoizedFormConfig = useMemo(() => createHonoraryMemberForm, [createHonoraryMemberForm]);

  return (
    <div className="membership-application">
      <div className="vertical-form">
        {isSuccess ?
          <FormCreator
            config={memoizedFormConfig}
            ref={createHonoraryMemberFormRef}
            key={false}
            onColumnChange={memoizedHandleFieldChange}
            onActionChange={handleActionChange}
          /> : <PageLoader />
        }
      </div>
      {isSuccess && <div className="d-flex justify-content-between">
        <div>
          <Buttons
            onClick={handleBack}
            buttonText={"Back"}
            buttonTypeClassName="back-btn btn"
            isLoading={false}
          />
        </div>
        <div>
          <Buttons
            onClick={handleSave}
            buttonText={"Save"}
            buttonTypeClassName="theme-btn btn mt-auto"
            isLoading={saveMemberDetailsIsLoading}
          />
        </div>
      </div>
      }
    </div>
  );
};

export default CreateHonoraryMemberForm;
